import { Helmet } from "react-helmet-async";

import { MDBContainer } from "mdbreact";
import HomeHero from "./HomeHero";
import HomeActions from "./HomeActions";
import HomeServices from "./HomeServices";
import HomeTestimonials from "./HomeTestimonials";
import HomeNewsletter from "./HomeNewsletter";
import Search from "Components/Search/Search";

export default function Home() {
  return (
    <main>
      <Helmet>
        <title>Turistička agencija Mozaik 021 Novi Sad</title>
      </Helmet>
      <HomeHero />
      <MDBContainer>
        <Search home />
        <HomeActions />
        <HomeServices />
        <HomeTestimonials />
        <HomeNewsletter />
      </MDBContainer>
    </main>
  );
}

// import TestimonialList from "./testimonials/TestimonialList";
// import Features from "./features/Features";
// import CallToAction from "./CallToAction/CallToAction";
// import Search from "../../Search/Search";
// import Subscribe from "./subscribe/Subscribe";

// import imgBg from "./images/bg1.jpg";

// export default function Home() {
//   return (
//     <main>

//       <MDBContainer>
//         <Search home />
//         <CallToAction />
//         <Features />
//         <TestimonialList />
//         <Subscribe />
//       </MDBContainer>
//     </main>
//   );
// }
